<template lang="pug">
  .module__main
    .module__title Настройки Deeplink и QR
    .module-content__container(v-loading="isLoading")
      .settings__container
        .setting__container
          .setting__title Генерация диплинков
          .payment-settings__list
            .payment-setting__container(v-for="(setting, system) in generateDeeplinkForPaymentSystem" :key="`generate-deeplink-${system}`")
              .general-setting__container.one-line
                .payment-setting__title.mr5 {{ paymentSystems[system] || system }}
                .payment-setting__value
                  el-checkbox(v-model="generateDeeplinkForPaymentSystem[system]" @change="editPaymentsSettings('generateDeeplinkForPaymentSystem')")
        .setting__container
          .setting__title Генерация QR
          .payment-settings__list
            .payment-setting__container(v-for="(setting, system) in generateQrForPaymentSystem" :key="`generate-qr-${system}`")
              .general-setting__container.one-line
                .payment-setting__title.mr5 {{ paymentSystems[system] || system }}
                .payment-setting__value
                  el-checkbox(v-model="generateQrForPaymentSystem[system]" @change="editPaymentsSettings('generateQrForPaymentSystem')")
        .setting__container
          .setting__title Банки для диплинков
          .payment-settings__list
            .payment-setting__container(v-for="(setting, system) in supportedDeeplinkBanksIds" :key="`supported-deeplink-banks-${system}`")
              .payment-setting__title.mb5 {{ paymentSystems[system] || system }}
              el-checkbox-group.banks__block(v-model="supportedDeeplinkBanksIds[system]")
                .bank-option(v-for="bank in deeplinksBanks" :key="`dl-ps-${system}-bank-${bank.id}`")
                  el-checkbox(:label="bank.id") {{ bank.name }}
                  el-button.interbank-exclude-banks-ids__btn(
                    circle
                    size="mini"
                    @click="activateBankIdExcludedSaudiPaymentMethodsEdit(system, 'deeplink', bank)"
                  ) {{ deeplinkBankIdExcludedSaudiPaymentMethods[system][bank.id]?.length || 0 }}
          .payment-edit__button
            el-button(
              type="primary"
              size="mini"
              @click="editPaymentsSettings('supportedDeeplinkBanksIds')"
            ) Обновить
        .setting__container
          .setting__title Банки для QR
          .payment-settings__list
            .payment-setting__container(v-for="(setting, system) in supportedQrBanksIds" :key="`supported-qr-banks-${system}`")
              .payment-setting__title.mb5 {{ paymentSystems[system] || system }}
              el-checkbox-group.banks__block(v-model="supportedQrBanksIds[system]")
                .bank-option(v-for="bank in qrBanks" :key="`qr-ps-${system}-bank-${bank.id}`")
                  el-checkbox(:label="bank.id") {{ bank.name }}
                  el-button.interbank-exclude-banks-ids__btn(
                    circle
                    size="mini"
                    @click="activateBankIdExcludedSaudiPaymentMethodsEdit(system, 'qr', bank)"
                  ) {{ qrBankIdExcludedSaudiPaymentMethods[system][bank.id]?.length || 0 }}
          .payment-edit__button
            el-button(
              type="primary"
              size="mini"
              @click="editPaymentsSettings('supportedQrBanksIds')"
            ) Обновить
    el-dialog(:visible.sync="showBankIdExcludedSaudiPaymentMethodsEdit" :before-close="resetBankIdExcludedSaudiPaymentMethodsEdit" :title="bankIdExcludedSaudiPaymentMethodsEditTitle" width="40%")
      el-checkbox-group.banks-ids__list(v-model="bankIdExcludedSaudiPaymentMethodsEdit.saudi_methods")
        el-checkbox.exclude-bank(v-for="(name, method) in saudiPaymentMethods" :label="method" :key="`exclude-method-${method}`") {{name}}
      .exchange-finish__buttons
        el-button(type="success" @click="updateBankIdExcludedSaudiPaymentMethods()") Обновить
        el-button(type="danger" @click="resetBankIdExcludedSaudiPaymentMethodsEdit()") Отменить
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  LOAD_DEEPLINK_AND_QR_SETTINGS,
  UPDATE_DEEPLINK_AND_QR_SETTINGS,
} from '../../store/const/settings';

export default {
  name: 'DeeplinkAndQr',
  data() {
    return {
      generateDeeplinkForPaymentSystem: {
        "card": false,
        "sim": false,
        "sbp": false,
        "bank_account": false,
        "foreign_card": false,
        "foreign_sbp": false,
        "qr": false,
        "interbank": false,
        "qr_interbank": false,
      },
      generateQrForPaymentSystem: {
        "card": false,
        "sim": false,
        "sbp": false,
        "bank_account": false,
        "foreign_card": false,
        "foreign_sbp": false,
        "qr": false,
        "interbank": false,
        "qr_interbank": false,
      },
      supportedDeeplinkBanksIds: {
        "card": [],
        "sim": [],
        "sbp": [],
        "bank_account": [],
        "foreign_card": [],
        "foreign_sbp": [],
        "qr": [],
        "interbank": [],
        "qr_interbank": [],
      },
      supportedQrBanksIds: {
        "card": [],
        "sim": [],
        "sbp": [],
        "bank_account": [],
        "foreign_card": [],
        "foreign_sbp": [],
        "qr": [],
        "interbank": [],
        "qr_interbank": [],
      },
      saudiPaymentSystems: [],
      deeplinkBankIdExcludedSaudiPaymentMethods: {},
      qrBankIdExcludedSaudiPaymentMethods: {},
      bankIdExcludedSaudiPaymentMethodsEdit: {
        payment_system: undefined,
        mode: undefined,
        bank_id: undefined,
        bank_name: undefined,
        saudi_methods: [],
      }
    }
  },
  async mounted() {
    await this.loadAndSetSettings();
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    ...mapGetters('settings', [
      'paymentSystems',
    ]),
    ...mapGetters('exchange', [
      'deeplinksBanks',
      'qrBanks',
    ]),
    isLoading() {
      return this.loading(LOAD_DEEPLINK_AND_QR_SETTINGS) === 'loading';
    },
    saudiPaymentMethods() {
      const result = {};
      for (const method of this.saudiPaymentSystems) {
        result[method.name] = method.alias;
      }
      return result;
    },
    showBankIdExcludedSaudiPaymentMethodsEdit() {
      return !!this.bankIdExcludedSaudiPaymentMethodsEdit.payment_system;
    },
    bankIdExcludedSaudiPaymentMethodsEditTitle() {
      return `Настройка исключений генерации ${this.bankIdExcludedSaudiPaymentMethodsEdit.mode} в платёжной системе ${this.paymentSystems[this.bankIdExcludedSaudiPaymentMethodsEdit.payment_system]} для банка ${this.bankIdExcludedSaudiPaymentMethodsEdit.bank_name}`;
    },
  },
  methods: {
    ...mapActions('settings', {
      loadSettings: LOAD_DEEPLINK_AND_QR_SETTINGS,
      updateSetting: UPDATE_DEEPLINK_AND_QR_SETTINGS,
    }),
    async loadAndSetSettings() {
      const request = await this.loadSettings();
      if (request.success) {
        const settings = request.data;
        for (const settingName of Object.keys(settings)) {
          this[settingName] = settings[settingName];
        }
      }
    },
    async requestSettingUpdate(name, setting) {
      const request = await this.updateSetting({ name, setting });
      if (request.success) {
        this.$message.success('Настройки успешно обновлены');
        await this.loadAndSetSettings();
        return true;
      } else {
        this.$message.error(`Ошибка обновления настроек: ${request.message || 'Неизвестная ошибка'}`);
        return false;
      }
    },
    async editPaymentsSettings(settingsName) {
      return await this.requestSettingUpdate(settingsName, this[settingsName]);
    },
    activateBankIdExcludedSaudiPaymentMethodsEdit(payment_system, mode, bank) {
      this.bankIdExcludedSaudiPaymentMethodsEdit.bank_id = bank.id;
      this.bankIdExcludedSaudiPaymentMethodsEdit.bank_name = bank.name;
      this.bankIdExcludedSaudiPaymentMethodsEdit.mode = mode;
      const bankIdExcludedSaudiPaymentMethods = mode === 'deeplink'
        ? this.deeplinkBankIdExcludedSaudiPaymentMethods
        : this.qrBankIdExcludedSaudiPaymentMethods;
      this.bankIdExcludedSaudiPaymentMethodsEdit.saudi_methods = bankIdExcludedSaudiPaymentMethods[payment_system][bank.id] || [];
      this.bankIdExcludedSaudiPaymentMethodsEdit.payment_system = payment_system;
    },
    resetBankIdExcludedSaudiPaymentMethodsEdit() {
      this.bankIdExcludedSaudiPaymentMethodsEdit.payment_system = undefined;
      this.bankIdExcludedSaudiPaymentMethodsEdit.saudi_methods = [];
      this.bankIdExcludedSaudiPaymentMethodsEdit.bank_id = undefined;
      this.bankIdExcludedSaudiPaymentMethodsEdit.bank_name = undefined;
      this.bankIdExcludedSaudiPaymentMethodsEdit.mode = undefined;
    },
    async updateBankIdExcludedSaudiPaymentMethods() {
      const updateParentObject = this.bankIdExcludedSaudiPaymentMethodsEdit.mode === 'deeplink'
        ? this.deeplinkBankIdExcludedSaudiPaymentMethods
        : this.qrBankIdExcludedSaudiPaymentMethods;
      const updateObject = {
        ...updateParentObject,
        [this.bankIdExcludedSaudiPaymentMethodsEdit.payment_system]: {
          ...updateParentObject[this.bankIdExcludedSaudiPaymentMethodsEdit.payment_system],
          [this.bankIdExcludedSaudiPaymentMethodsEdit.bank_id]: this.bankIdExcludedSaudiPaymentMethodsEdit.saudi_methods
        },
      };
      const updateSettingName = this.bankIdExcludedSaudiPaymentMethodsEdit.mode === 'deeplink'
        ? 'deeplinkBankIdExcludedSaudiPaymentMethods'
        : 'qrBankIdExcludedSaudiPaymentMethods';
      const isRequestSuccess = await this.requestSettingUpdate(updateSettingName, updateObject, this.bankIdExcludedSaudiPaymentMethodsEdit.mode, this.bankIdExcludedSaudiPaymentMethodsEdit.mode === 'interbank');
      if (isRequestSuccess) {
        this.resetBankIdExcludedSaudiPaymentMethodsEdit();
      }
    },
  }
};
</script>
<style scoped>
.settings__container {
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
}

.setting__container {
  width: 240px;
  padding: 10px;
  background-color: white;
  margin: 5px;
  border-radius: 5px;
  box-shadow: 1px 1px 1px #9f9f9f
}

.setting__title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
}

.setting__block {
  display: flex;
  flex-wrap: wrap;
  padding: 5px;
  margin-bottom: 5px;
}

.setting-block__title {
  font-weight: 500;
  flex: 1;
}

.handlers-priority__container {
  border: 1px solid #dcdfe6;
  border-radius: 5px;
}

.handler-priority__container {
  display: flex;
  padding: 4px;
  margin-bottom: 2px;
  align-items: center;
}

.handler-priority__btns {
  margin-left: 5px;
}

.handler-add__container {
  display: flex;
  align-items: center;
}

.handler-add__btn {
  width: 30px;
  height: 30px;
  margin: auto 5px;
}

.general-setting__container {
  margin-bottom: 10px;
  padding: 5px;
}

.general-setting__container:first-child {
  padding-top: 0;
}

.general-setting__container.one-line {
  display: flex;
  align-items: center;
}

.general-setting__container.one-line .setting__title {
  margin-right: 5px;
  margin-bottom: 0;
}

.payment-setting__container {
  margin-bottom: 5px;
  padding: 4px;
  border: 1px solid #e7e7e7;
}

.payment-setting__value {
  display: flex;
  align-items: center;
}

.banks__block {
  display: flex;
  flex-direction: column;
}

.bank-option {
  display: flex;
  justify-content: space-between;
}
</style>
